import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { isEmpty } from 'lodash';
import { DateUtils, TrackingUtils } from '../../utils';
import { CMS } from '../../utils/CMS';
import { TripType } from '../../models/TripType';
import { DropdownItem } from '../../components/DropdownItem/DropdownItem';

export class PreviousSearchItemDesktop extends PureComponent {
    onClick = () => {
        const { value, onClickItem } = this.props;
        this.trackClickEvent();
        onClickItem(value);
    };

    getRenderedElements([left, middle, right]) {
        return (
            <span className="odf-display-inline-flex">
                <span className="odf-space-outer-right-xs">{left}</span>
                <span className="odf-space-outer-right-xs">{middle}</span>
                <span>{right}</span>
            </span>
        );
    }

    getCitiesToRender() {
        const { segments, tripType } = this.props.value;
        const segmentsToRender = tripType === TripType.MULTIPLE ? segments.length : 1;
        return []
            .concat(
                ...segments.slice(0, segmentsToRender).map((leg) => [leg.origin, leg.destination]),
            )
            .map((segment) => segment.city)
            .reduce((prev, curr) => this.getRenderedElements([prev, ' - ', curr]));
    }

    getDatesToRender() {
        const { segments } = this.props.value;
        return segments
            .filter((s) => s.date)
            .map(this.parseSegmentDate)
            .reduce((prev, curr) => this.getRenderedElements([prev, ' - ', curr]));
    }

    parseSegmentDate = (segment) => {
        const format = DateUtils.Format.UTC;
        return DateUtils.toString(segment.date, format);
    };

    trackClickEvent = () => {
        const { index, trackingId } = this.props;
        const label = `search_recent_${index + 1}`;
        const trackingIdAction = !isEmpty(trackingId) ? `_${trackingId}` : '';
        TrackingUtils.trackEvent(`recent_search${trackingIdAction}`, label, 'home');
    };

    render() {
        const { value } = this.props;
        const { adults, kids, infants } = value.pax;
        return (
            <DropdownItem onClick={this.onClick}>
                {this.getCitiesToRender()}
                <div className="odf-dropdown-extra">
                    {this.getDatesToRender()}
                    &nbsp;&middot;&nbsp;
                    <span className="odf-display-inline-flex">
                        <span>
                            <CMS id="paxSelector.adult.text" values={{ count: adults }} />
                        </span>
                        {kids > 0 && (
                            <span>
                                , <CMS id="paxSelector.child.text" values={{ count: kids }} />
                            </span>
                        )}
                        {infants > 0 && (
                            <span>
                                , <CMS id="paxSelector.infant.text" values={{ count: infants }} />
                            </span>
                        )}
                    </span>
                </div>
            </DropdownItem>
        );
    }
}

PreviousSearchItemDesktop.propTypes = {
    index: PropTypes.number.isRequired,
    onClickItem: PropTypes.func.isRequired,
    value: PropTypes.object.isRequired,
    trackingId: PropTypes.string,
};

PreviousSearchItemDesktop.defaultProps = {
    trackingId: '',
};
